import moment from "moment";

const organization = [
  {
    Name: "Brooklyn",
    Description: "Pharmaceutical Manufacturers",
  },
  {
    Name: "Tiffany & Co",
    Description: "Shop fine jewelry creations",
  },
  {
    Name: "GreenPages",
    Description: "Leading systems integrator",
  },
  {
    Name: "LeadSquared",
    Description: "Complete Marketing Automation",
  },
];

const os = [
  "AMAZON_LINUX",
  "AMAZON_LINUX_2",
  "REDHAT_ENTERPRISE_LINUX",
  "SUSE",
  "CENTOS",
  "UBUNTU",
  "WINDOWS",
];

const osPlatform = [
  {
    os: "AMAZON_LINUX",
    platform: "LINUX",
  },
  {
    os: "AMAZON_LINUX_2",
    platform: "LINUX",
  },
  {
    os: "REDHAT_ENTERPRISE_LINUX",
    platform: "LINUX",
  },
  {
    os: "SUSE",
    platform: "LINUX",
  },
  {
    os: "CENTOS",
    platform: "LINUX",
  },
  {
    os: "UBUNTU",
    platform: "LINUX",
  },
  {
    os: "WINDOWS",
    platform: "WINDOWS",
  },
];

const departments = [
  {
    Description: "High Computational Analysis",
    ID: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Name: "High Computational Analysis",
    OrganizationId: "791e1c40-a515-45cb-95d7-152915fc5c79",
    CreatedBy: 7,
    CreatedOn: "Jan 30th 2022",
    cost: "10453.5",
    currency: "USD",
    Metadata: {
      PointPerson: "Michael Keating",
      Owner: "John Peters",
      GroupName: "Calcs",
      BudgetExist: true,
      BudgetValue: 1200,
    },
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "10d9a58e-3cc8-51ee-bfd9-8d39da171138",
      ],
      Other: "AWS Compute Custom",
    },
    Users: 10,
    Applications: 3,
  },
  {
    Description: "Data Analysis for PhD",
    ID: "72ka91b7-551f-4d35-a113-b37fcd840a71",
    Name: "Data Analysis",
    OrganizationId: "791e1c40-a515-45cb-95d7-152915fc5c79",
    CreatedBy: 7,
    CreatedOn: "Feb 15th 2022",
    cost: "10453.5",
    currency: "USD",
    Metadata: {
      PointPerson: "Michael Keating",
      Owner: "Timothy Pearson",
      GroupName: "Calcs",
      BudgetExist: true,
      BudgetValue: 1200,
    },
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "10d9a58e-3cc8-51ee-bfd9-8d39da171138",
      ],
      Other: "AWS Compute Custom",
    },
    Users: 3,
    Applications: 3,
  },
  {
    Description: "Game Theory Calculation Designs",
    ID: "31rba91b7-551f-4d35-a113-b37fcd840a71",
    Name: "Game Theory Computations",
    OrganizationId: "791e1c40-a515-45cb-95d7-152915fc5c79",
    CreatedBy: 7,
    CreatedOn: "Feb 14th 2022",
    cost: "10453.5",
    currency: "USD",
    Metadata: {
      PointPerson: "Michael Keating",
      Owner: "Timothy Pearson",
      GroupName: "Calcs",
      BudgetExist: true,
      BudgetValue: 1200,
    },
    Services: {
      Blueprints: [
        "31023c1e-969f-5347-a7cf-0398e8a521e1",
        "29028135-5a54-5409-8081-8bd1c2eec2a3",
      ],
      Other: "AWS Compute Custom",
    },
    Users: 3,
    Applications: 0,
  },
  {
    ID: "830e65e6-c6ca-42b3-8b9d-2260cf3ac09e",
    Name: "Home Delivery Team",
    Description: "Logistics, shipping and returns department",
    cost: "10453.5",
    currency: "USD",
  },
  {
    ID: "6fd25c90-b7d2-49c1-ace9-945cb173e3d6",
    Name: "Reverie Team",
    Description: "General, Personal, Advice, and Art team",
    cost: "10453.5",
    currency: "USD",
  },
  {
    ID: "7210aacc-b7f2-4fde-9736-8945e994bead",
    Name: "Pharmacy Team",
    Description: "Medical team",
    cost: "10453.5",
    currency: "USD",
  },
  {
    ID: "ad8ec0a0-62a9-4a87-9a6e-233ed5380bce",
    Name: "Finance Team",
    Description: "Finance team",
    cost: "10453.5",
    currency: "USD",
  },
];

const pharmacyDept = [
  {
    ID: "6",
    Name: "Pharmacy Team",
    Description: "Medical team",
  },
];

const applications1 = [
  {
    ID: "7235fa89-9fab-46ec-b81b-4ec1a8840ede",
    Name: "High Computation Production",
    Description: "High-Computation-Production",
    EnvironmentId: "c0deeb10-c1ff-4a1d-b0ad-aea49fd66454",
    EnvironmentName: "Prod",
    Cost: "150.23",
    Currency: "USD",
  },
  {
    ID: "a437f8d8-23cc-4a9c-bccb-d76fa846e665",
    Name: "High-Computation-DevTest",
    Description: "High-Computation-DevTest",
    EnvironmentId: "4674bc39-c966-4a74-81f1-84723aaf6702",
    EnvironmentName: "Dev",
    CreatedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
    Cost: "1010.23",
    Currency: "USD",
  },
  {
    ID: "80e75ebb-077a-436e-af0a-0cd88390d658",
    Name: "ElasticSearch-Dev",
    description: "ElasticSearch-Dev",
    EnvironmentId: "14a6531d-9101-4c87-983b-146a89eabc5b",
    EnvironmentName: "Dev",
    Cost: "1022.03",
    Currency: "USD",
  },
];
const accounts1 = [
  {
    AccountName: "Brooklyn Product Prod",
    AccountNumber: "904433914959",
    AccountStatus: "Active",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Product DevTest",
    AccountNumber: "591335929153",
    AccountStatus: "Active",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
  },
];
const applications2 = [
  {
    ID: "248d6b09-2ceb-499e-8b8c-1067b1970de9",
    Name: "Data-Analysis-Prod",
    Description: "Data-Analysis-Prod",
    EnvironmentId: "31dfdce5-899e-4736-bab2-1e79816337dd",
    EnvironmentName: "Prod",
    Cost: "1122.21",
    Currency: "USD",
  },
  {
    ID: "817fdbcc-e19f-4936-8c43-f6a8205640cf",
    Name: "Data-Analysis-Test",
    Description: "Data-Analysis-Test",
    EnvironmentId: "5e282d66-806a-40ca-b4b9-ce9fccf7c12c",
    EnvironmentName: "Dev",
    Cost: "1530.36",
    Currency: "USD",
  },
  {
    ID: "028bdf21-0a29-4f24-b538-75a9af91633f",
    Name: "Data-Analysis-Staging",
    EnvironmentName: "Staging",
    Description: "Data-Analysis-Staging",
    EnvironmentId: "5e282d66-806a-40ca-b4b9-ce9fccf7ty12n",
    Cost: "1260.90",
    Currency: "USD",
  },
];
const accounts2 = [
  {
    AccountName: "Brooklyn Security Prod",
    AccountNumber: "500608819332",
    AccountStatus: "Active",
    DepartmentId: "72ka91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Security Test",
    AccountNumber: "263404293554",
    AccountStatus: "Active",
    DepartmentId: "72ka91b7-551f-4d35-a113-b37fcd840a71",
  },
];
const applications3 = [
  {
    ID: "6e476276-47e0-4dc3-9e4f-4adf86ae0ce9",
    Name: "Compliance-App-Prod",
    Description: "Compliance-App-Prod",
    EnvironmentId: "5bc3bbf3-72d3-4c19-8939-36b5968dad0b",
    EnvironmentName: "Prod",
    Cost: "1456.78",
    Currency: "USD",
  },
  {
    ID: "28657229-4063-49f5-a569-8b0ee35e6cef",
    Name: "Compliance-App-Test",
    Description: "Compliance-App-Test",
    EnvironmentId: "02ff981f-b02f-404c-a9f7-3cd95f3d46d3",
    EnvironmentName: "Dev",
    Cost: "1123.23",
    Currency: "USD",
  },
  {
    ID: "a5a670de-59f0-4a3a-9b33-aefbfe9c2e22",
    Name: "Network-App-Test",
    Description: "Network-App-Test",
    EnvironmentId: "5021cb7d-cff6-4fc5-853e-783fc024c3c4",
    EnvironmentName: "Dev",
    Cost: "1700",
    Currency: "USD",
  },
  {
    ID: "36fd0595-0d8b-4110-9644-e6d632f64b40",
    Name: "Auth-App-Prod",
    Description: "Auth-App-Prod",
    EnvironmentId: "c9aa694d-d81e-48dc-8283-3e2d20a81bbe",
    EnvironmentName: "Prod",
    Cost: "1432.23",
    Currency: "USD",
  },
  {
    ID: "06d3ca13-ef19-49dd-8c48-bc6b9c2d2689",
    Name: "DisasterRecovery-App-Test",
    Description: "DisasterRecovery-App-Test",
    EnvironmentId: "74894c2b-6179-4e9c-8d44-d5c8e7b9bc8a",
    EnvironmentName: "Dev",
    Cost: "1340",
    Currency: "USD",
  },
  {
    ID: "de960155-16d7-4341-8402-f600930cd2b1",
    Name: "QualityAssurance-App-Prod",
    Description: "QualityAssurance-App-Prod",
    EnvironmentId: "aaca9441-cea2-45c2-ac79-56681bbe685c",
    EnvironmentName: "Prod",
    Cost: "1000.23",
    Currency: "USD",
  },
];
const accounts3 = [
  {
    AccountName: "Brooklyn Master",
    AccountNumber: "932383143047",
    AccountStatus: "Active",
    DepartmentId: "31rba91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Core",
    AccountNumber: "452309014589",
    AccountStatus: "Active",
    DepartmentId: "31rba91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Central Logging",
    AccountNumber: "328189647004",
    AccountStatus: "Active",
    DepartmentId: "31rba91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Shared Services",
    AccountNumber: "964659314314",
    AccountStatus: "Active",
    DepartmentId: "31rba91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Security Account",
    AccountNumber: "612020440690",
    AccountStatus: "Active",
    DepartmentId: "31rba91b7-551f-4d35-a113-b37fcd840a71",
  },
  {
    AccountName: "Brooklyn Sandbox Account",
    AccountNumber: "700953207471",
    AccountStatus: "Active",
    DepartmentId: "31rba91b7-551f-4d35-a113-b37fcd840a71",
  },
];
const applications4 = [
  {
    ID: "55de78be-bb3e-4660-826e-d54ed25a5b5d",
    Name: "Invoicing-App-Prod",
    Description: "Invoicing-App-Prod",
    EnvironmentId: "aaca9441-cea2-3222-ac79-56681bbe685c",
    EnvironmentName: "Prod",
    Cost: "1410.23",
    Currency: "USD",
  },
];
const accounts4 = [
  {
    AccountName: "Brooklyn Logistics Prod",
    AccountNumber: "479922861820",
    AccountStatus: "Active",
    DepartmentId: "830e65e6-c6ca-42b3-8b9d-2260cf3ac09e",
  },
  {
    AccountName: "Brooklyn Logistics DevTest",
    AccountNumber: "702761640204",
    AccountStatus: "Active",
    DepartmentId: "830e65e6-c6ca-42b3-8b9d-2260cf3ac09e",
  },
];
const applications5 = [
  {
    ID: "ff438c79-a74a-45ee-a539-0f4e67eeb2c8",
    Name: "Reverie-App-Dev",
    Description: "Reverie-App-Dev",
    EnvironmentId: "55b89590-1c22-4e96-aac5-70dbf333c941",
    EnvironmentName: "Dev",
  },
];
const accounts5 = [
  {
    AccountName: "Brooklyn Reverie Account",
    AccountNumber: "771592380082",
    AccountStatus: "Active",
    DepartmentId: "6fd25c90-b7d2-49c1-ace9-945cb173e3d6",
  },
];
const applications6 = [
  {
    ID: "e20b5157-3963-4c11-a53d-f01d702a8a5c",
    Name: "React-App-Dev",
    Description: "React-App-Dev",
    EnvironmentId: "8f584c32-0107-48ca-835e-f0fcc0f76689",
    EnvironmentName: "Dev",
  },
  {
    ID: "74bc9729-1072-480e-bd85-dc64f87e11da",
    Name: "Windows-Server-Dev",
    Description: "Windows-Server-Dev",
    EnvironmentId: "30d5a8c6-fe5a-4393-b35c-563a2442aa42",
    EnvironmentName: "Dev",
    Cost: "1345.23",
    Currency: "USD",
  },
];
const accounts6 = [
  {
    AccountName: "Brooklyn Pharmacy Account",
    AccountNumber: "771592380081",
    AccountStatus: "Active",
    DepartmentId: "7210aacc-b7f2-4fde-9736-8945e994bead",
  },
  {
    AccountName: "Brooklyn Pharmacy DevTest",
    AccountNumber: "562981745291",
    AccountStatus: "Active",
    DepartmentId: "7210aacc-b7f2-4fde-9736-8945e994bead",
  },
];
const applications7 = [
  {
    ID: "245016cb-cd48-4950-962f-06ffdbb0969b",
    Name: "Finance-App-Dev",
    Description: "Finance-App-Dev",
    EnvironmentId: "30d5a8c6-fe5a-6903-b35c-563a2442aa42",
    EnvironmentName: "Dev",
    Cost: "1323.23",
    Currency: "USD",
  },
];
const accounts7 = [
  {
    AccountName: "Brooklyn Finance Account",
    AccountNumber: "771592380085",
    AccountStatus: "Active",
    DepartmentId: "ad8ec0a0-62a9-4a87-9a6e-233ed5380bce",
  },
];

const serverGroups = [
  {
    Name: "Pharmacy-App-Prod-Servers",
    Description: "Pharmacy App group (Production)",
  },
  {
    Name: "Security-App-Prod-Servers",
    Description: "Security App group (Production)",
  },
  {
    Name: "Security-App-Staging-Servers",
    Description: "Security App group (Staging)",
  },
  {
    Name: "Security-App-Test-Servers",
    Description: "Security App group (Test)",
  },
  {
    Name: "Ecommerce-App-Prod--Servers",
    Description: "Ecommerce App group (Production)",
  },
  {
    Name: "Ecommerce-App-Staging",
    Description: "Invetory App group (Staging)",
  },
  {
    Name: "Ecommerce-App-Test-Servers",
    Description: "Invetory App group (Test)",
  },
  {
    Name: "Invoicing-App-Prod-Servers",
    Description: "Invoicing App group (Production)",
  },
  {
    Name: "Invoicing-App-Staging-Servers",
    Description: "Invoicing App group (Staging)",
  },
  {
    Name: "Invoicing-App-Test-Servers",
    Description: "Invoicing App group (Test)",
  },
];

const allIntegrations = {
  Slack: [
    {
      ChannelName: "Core_Product_App_Health_Channel",
      Description: "IT Application Health Channel",
    },
    {
      ChannelName: "Core_Product_DevOps_Channel",
      Description: "Deployment and Operations Channel",
    },
    {
      ChannelName: "Core_Product_Security_Channel",
      Description: "Security Discussions Channel",
    },
  ],
  SNS: [
    {
      ChannelName: "Core_Product_Security_Alerts",
      Description: "Dedicated notifications for Security Alerts",
    },
    {
      ChannelName: "React_App_Status_Changes",
      Description: "React App Team Notifications",
    },
    {
      ChannelName: "Data_Hub_App_Status_Changes",
      Description: "Data Hub App Team Notifications",
    },
  ],
};

const patchPolicies = [
  {
    policyName: "Zero-Day-Vulnerability-Windows-Server-Policy",
    Description: "Zero day vulnerabilities for Windows Server",
    operatingSystem: "WINDOWS",
  },
  {
    policyName: "Zero-Day-Vulnerability-AmazonLinux-Server-Policy",
    Description: "Zero day vulnerabilities for Amzon Linux 1, Amzon Linux 2",
    operatingSystem: "AMAZON_LINUX",
  },
  {
    policyName: "Zero-Day-Vulnerability-RHEL-Server-Policy",
    Description: "Zero day vulnerabilities for RHEL",
    operatingSystem: "REDHAT_ENTERPRISE_LINUX",
  },
  {
    policyName: "Zero-Day-Vulnerability-Ubuntu-Server-Policy",
    Description: "Zero day vulnerabilities for Ubuntu",
    operatingSystem: "UBUNTU",
  },
  {
    policyName: "Zero-Day-Vulnerability-Centos-Server-Policy	",
    Description: "Zero day vulnerabilities for Cent OS",
    operatingSystem: "CENTOS",
  },
  {
    policyName: "Zero-Day-Vulnerability-SUSE-Server-Policy",
    Description: "Zero day vulnerabilities for SUSE",
    operatingSystem: "SUSE",
  },
  {
    policyName: "Meltdown-and-Spectre-Windows-Server-Policy",
    Description: "Meltdown and Spectre policy for Windows Server",
    operatingSystem: "WINDOWS	",
  },
  {
    policyName: "Meltdown-and-Spectre-RHEL-Server-Policy",
    Description: "Meltdown and Spectre policy for RHEL",
    operatingSystem: "REDHAT_ENTERPRISE_LINUX",
  },
];

const allApplications = () => {
  const allApps = [];
  applications1.forEach((app) => {
    app.DepartmentId = activeProjects[0].ID;
    app.DepartmentName = activeProjects[0].Name;
    allApps.push(app);
  });
  applications2.forEach((app) => {
    app.DepartmentId = activeProjects[1].ID;
    app.DepartmentName = activeProjects[1].Name;
    allApps.push(app);
  });
  applications3.forEach((app) => {
    app.DepartmentId = departments[2].ID;
    app.DepartmentName = departments[2].Name;
    allApps.push(app);
  });
  applications4.forEach((app) => {
    app.DepartmentId = departments[3].ID;
    app.DepartmentName = departments[3].Name;
    allApps.push(app);
  });
  applications5.forEach((app) => {
    app.DepartmentId = departments[4].ID;
    app.DepartmentName = departments[4].Name;
    allApps.push(app);
  });
  applications6.forEach((app) => {
    app.DepartmentId = departments[5].ID;
    app.DepartmentName = departments[5].Name;
    allApps.push(app);
  });
  applications7.forEach((app) => {
    app.DepartmentId = departments[6].ID;
    app.DepartmentName = departments[6].Name;
    allApps.push(app);
  });
  let proccessedApps = [];
  allApps.forEach((app) => {
    app.Status = "ACTIVE";
    app.CreatedOn = moment().format("YYYY-MM-DD HH:mm:ss");
    app.CreatedBy = "Cloud Admin";
    proccessedApps.push(app);
  });
  return proccessedApps;
};

const projectRequests = [
  {
    ID: "9aba91b7-551f-4d35-a113-b37fcd840a71",
    Description: "GPDC IT Department",
    Name: "Sales Department",
    CreatedBy: 7,
    CreatedAt: "Jan 29th 2022",
    State: "Pending",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Johnny Delgato",
      Owner: "Timothy Pearson",
      GroupName: "Fall Season 2022",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 3rd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "10d9a58e-3cc8-51ee-bfd9-8d39da171138",
      ],
      Other: "AWS Compute Custom",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
  },
  {
    ID: "5bba91b7-551f-4d35-a113-b37fcd840a71",
    Description: "GPDC IT Department",
    Name: "IT Department",
    CreatedBy: 7,
    CreatedAt: "Jan 29th 2022",
    State: "Pending",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Johnny Delgato",
      Owner: "Timothy Pearson",
      GroupName: "Fall Season 2022",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 3rd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "466eba3e-e766-54c4-8f8e-b83b025ac082",
        "4feb5438-af67-54af-b4e6-dc820f6c5142",
      ],
      Other: "AWS Compute Custom",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
  },
  {
    ID: "bb8a91b7-551f-4d35-a113-b37fcd840a71",
    Description: "GPDC IT Department",
    Name: "Data Warehousing",
    CreatedBy: 7,
    CreatedAt: "Jan 26th 2022",
    State: "WITHDRAWN",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Johnny Delgato",
      Owner: "Michael Keters",
      GroupName: "Fall Season 2022",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 7thd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "6e60bf60-5c08-5a60-92aa-b9bc343343fb",
        "6fde1654-cd1c-5989-aee5-924c3f3f24a8",
      ],
      Other: "AWS Compute Custom",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
  },
  {
    ID: "bb8a81b7-551f-4d35-a113-b37fcd840a71",
    Description: "GPDC IT Department",
    Name: "High Computing Tasks",
    CreatedBy: 7,
    CreatedAt: "Jan 26th 2022",
    State: "REJECTED",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Johnny Delgato",
      Owner: "Michael Keters",
      GroupName: "Fall Season 2022",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 7thd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "ab719e5e-31aa-58e9-843c-9f3a9f9dbc88",
        "bbe4019e-158f-5d37-ba55-8a0fb0836af4",
      ],
      Other: "AWS Compute Custom",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
    StateChangeMessage: "Incorrect services selected",
  },
];

const activeProjects = [
  {
    Description: "High Computational Analysis",
    ID: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Name: "High Computational Analysis",
    OrganizationId: "791e1c40-a515-45cb-95d7-152915fc5c79",
    CreatedBy: 7,
    CreatedOn: "Jan 30th 2022",
    Metadata: {
      PointPerson: "Michael Keating",
      Owner: "John Peters",
      GroupName: "Calcs",
      BudgetExist: true,
      BudgetValue: 1200,
    },
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "10d9a58e-3cc8-51ee-bfd9-8d39da171138",
      ],
      Other: "AWS Compute Custom",
    },
    Users: 10,
    Applications: 3,
  },
  {
    Description: "Data Analysis for PhD",
    ID: "72ka91b7-551f-4d35-a113-b37fcd840a71",
    Name: "Data Analysis",
    OrganizationId: "791e1c40-a515-45cb-95d7-152915fc5c79",
    CreatedBy: 7,
    CreatedOn: "Feb 15th 2022",
    Metadata: {
      PointPerson: "Michael Keating",
      Owner: "Timothy Pearson",
      GroupName: "Calcs",
      BudgetExist: true,
      BudgetValue: 1200,
    },
    Services: {
      Blueprints: [
        "08ba970e-c190-5bd5-8576-df5ac27bdf0b",
        "1f4af570-4ca4-53b0-9ee1-1d61228369b6",
      ],
      Other: "AWS Compute Custom",
    },
    Users: 3,
    Applications: 3,
  },
  {
    Description: "Game Theory Calculation Designs",
    ID: "31rba91b7-551f-4d35-a113-b37fcd840a71",
    Name: "Game Theory Computations",
    OrganizationId: "791e1c40-a515-45cb-95d7-152915fc5c79",
    CreatedBy: 7,
    CreatedOn: "Feb 14th 2022",
    Metadata: {
      PointPerson: "Michael Keating",
      Owner: "Timothy Pearson",
      GroupName: "Calcs",
      BudgetExist: true,
      BudgetValue: 1200,
    },
    Services: {
      Blueprints: [
        "31023c1e-969f-5347-a7cf-0398e8a521e1",
        "29028135-5a54-5409-8081-8bd1c2eec2a3",
      ],
      Other: "AWS Compute Custom",
    },
    Users: 3,
    Applications: 0,
  },
];

const defaultValues = () => {
  return {
    organization,
    departments,
    pharmacyDept,
    allApplications: allApplications(),
    applications1,
    applications2,
    applications3,
    applications4,
    applications5,
    applications6,
    applications7,
    serverGroups,
    accounts1,
    accounts2,
    accounts3,
    accounts4,
    accounts5,
    accounts6,
    accounts7,
    allIntegrations,
    patchPolicies,
    os,
    osPlatform,
    projectRequests,
    activeProjects,
  };
};

export default defaultValues;
